// Icon.jsx
import * as ReactIcoMoon from "react-icomoon";
import iconSet from "./selection.json";

// Robustly handle the import. 
// In some SSR builds, it comes as { default: Component }
// In others (or dev), it might be the component itself or { default: { default: Component } } if double wrapped.
let IcoMoon = ReactIcoMoon.default || ReactIcoMoon;

// Unwrap potential double default export (common in CJS/ESM interop)
if (IcoMoon && typeof IcoMoon === 'object' && IcoMoon.default) {
    IcoMoon = IcoMoon.default;
}

const Icon = (props) => {
    // Safety check in case the import is still weird (like an object but not a valid React component type)
    if (!IcoMoon) return null;
    return <IcoMoon iconSet={iconSet} {...props} />;
};

export default Icon;
